(function () {
  'use strict';

  function initPowermark(root) {
    if (!root || root.dataset.pmReady === 'true') {
      return;
    }

    root.dataset.pmReady = 'true';

    var rm =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var hero = root.querySelector('.pmHero');
    var sheet = root.querySelector('.pmSheet');
    var runway = root.querySelector('.pmRunway');
    var enq = root.querySelector('.pmEnq');
    var footer = document.getElementById('main');

    if (!hero || !sheet || !runway) {
      return;
    }


    /* =========================================================
       HELPERS
    ========================================================= */

    function $$(selector, context) {
      return Array.prototype.slice.call(
        (context || root).querySelectorAll(selector)
      );
    }


    /* =========================================================
       REVEAL / INTERSECTION OBSERVER
    ========================================================= */

    var io = null;

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-in');

            io.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -10% 0px'
        }
      );
    }


    function arm() {
      var elements = $$('.pmCh, .pmFig, .pmRv, .pmWhyX__h');

      elements.forEach(function (element) {
        if (io) {
          io.observe(element);
        } else {
          element.classList.add('is-in');
        }
      });
    }


    hero.classList.add('is-in');

    arm();


    /* =========================================================
       HERO / SHEET SCROLL PROGRESS
    ========================================================= */

    var figs = $$('.pmFig[data-speed]');

    var ticking = false;
    var lastY = window.scrollY || 0;
    var enqDown = false;


    function update() {
      ticking = false;

      var vh = window.innerHeight;

      var sheetTop =
        sheet.getBoundingClientRect().top;

      var runHeight =
        runway.offsetHeight;

        

      var progress =
        runHeight > 0
          ? Math.min(
              1,
              Math.max(
                0,
                1 - sheetTop / runHeight
              )
            )
          : sheetTop <= 0
            ? 1
            : 0;


      root.style.setProperty(
        '--s',
        progress.toFixed(3)
      );


      /* -------------------------------------------------------
         STICKY ENQUIRE BUTTON
      ------------------------------------------------------- */

      if (enq) {
        var y = window.scrollY || 0;

        if (window.innerWidth > 900) {
          enqDown = false;
        } else if (y > lastY + 6) {
          enqDown = true;
        } else if (y < lastY - 6) {
          enqDown = false;
        }

        if (Math.abs(y - lastY) > 6) {
          lastY = y;
        }

        var footerVisible = true;

        if (footer) {
          footerVisible =
            footer.getBoundingClientRect().bottom >
            vh - 8;
        }

        enq.classList.toggle(
          'is-on',
          progress > 0.85 &&
          footerVisible &&
          !enqDown
        );
      }


      /* -------------------------------------------------------
         DESKTOP PARALLAX
      ------------------------------------------------------- */

      if (
        rm ||
        window.innerWidth <= 900
      ) {
        return;
      }


      figs.forEach(function (figure) {
        var rect =
          figure.getBoundingClientRect();

        var current =
          parseFloat(
            figure.style.getPropertyValue('--py')
          ) || 0;

        var top =
          rect.top - current;


        if (
          rect.bottom - current < -240 ||
          top > vh + 240
        ) {
          return;
        }


        var sink =
          parseFloat(
            figure.getAttribute('data-sink')
          );


        var speed =
          parseFloat(
            figure.getAttribute('data-speed')
          ) || 0;


        var py;


        if (sink) {
          py =
            sink *
            vh /
            100 *
            Math.min(
              1,
              Math.max(
                0,
                (vh * 0.7 - top) /
                (vh * 0.55)
              )
            );
        } else {
          py =
            Math.max(
              0,
              Math.min(
                28,
                -(top + rect.height / 2 - vh / 2) *
                speed
              )
            );
        }


        figure.style.setProperty(
          '--py',
          py.toFixed(1) + 'px'
        );
      });
    }


    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(update);
    }


    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate
    );


    update();


    /* =========================================================
       CATEGORY FILTER / STAGGER
    ========================================================= */

    var grid =
      root.querySelector('.pmGrid');

    var more =
      root.querySelector('.pmMore');

    var tabs =
      $$('.pmTab');
  var LIMIT = 6;

    function stagger() {
      if (!grid) {
        return;
      }

      var filter =
        grid.getAttribute('data-f') || 'all';


      var tiles =
        $$('.pmTile', grid)
          .filter(function (tile) {
            return tile.hasAttribute(
              'data-' + filter
            );
          });


      tiles
        .sort(function (a, b) {
          var aOrder =
            parseFloat(
              a.style.getPropertyValue(
                '--o-' + filter
              )
            ) || 0;

          var bOrder =
            parseFloat(
              b.style.getPropertyValue(
                '--o-' + filter
              )
            ) || 0;

          return aOrder - bOrder;
        });

$$('.pmTile', grid).forEach(function (tile) {

  tile.style.display = 'none';

});


        tiles.slice(0, 6).forEach(function (tile, index) {

           tile.style.display = '';

          tile.classList.toggle(
            'c1',
            index % 3 === 1
          );

          tile.classList.toggle(
            'c2',
            index % 3 === 2
          );

          tile.classList.toggle(
            'm1',
            index % 2 === 1
          );

        });
    }


    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function () {

          if (
            tab.getAttribute(
              'aria-pressed'
            ) === 'true'
          ) {
            return;
          }


          tabs.forEach(function (item) {

            item.setAttribute(
              'aria-pressed',
              String(item === tab)
            );

          });


          if (more) {
            more.href =
              tab.getAttribute(
                'data-url'
              ) || '#';
          }


          if (!grid) {
            return;
          }


          grid.classList.add(
            'is-swap'
          );


          window.setTimeout(
            function () {

              grid.setAttribute(
                'data-f',
                tab.getAttribute(
                  'data-f'
                ) || 'all'
              );


              stagger();


              grid.classList.remove(
                'is-swap'
              );

            },
            280
          );

        }
      );

    });


    stagger();


    /* =========================================================
       WHY LIMELIGHT CAROUSEL
    ========================================================= */

    var why =
      root.querySelector('.pmWhy');

    var dots =
      $$('.pmInd button');

    var mediaQuery =
      window.matchMedia
        ? window.matchMedia(
            '(max-width:900px)'
          )
        : null;

    var stops = [0];


    if (why) {

      function whyLayout() {

        var children =
          why.children;


        if (!children.length) {
          return;
        }


        var base =
          children[0].offsetLeft;


        var max =
          why.scrollWidth -
          why.clientWidth;


        var step =
          children.length > 1
            ? children[1].offsetLeft - base
            : why.clientWidth;


        stops = [];


        for (
          var i = 0;
          i < children.length;
          i++
        ) {

          var value =
            Math.min(
              children[i].offsetLeft -
              base,
              max
            );


          if (
            !stops.length ||
            value -
              stops[stops.length - 1] >
              2
          ) {
            stops.push(value);
          }

        }


        var visible =
          Math.max(
            1,
            Math.round(
              why.clientWidth /
              step
            )
          );


        dots.forEach(
          function (dot, index) {

            dot.style.display =
              index < stops.length
                ? ''
                : 'none';


            var start =
              index + 1;


            var end =
              Math.min(
                children.length,
                index + visible
              );


            dot.setAttribute(
              'aria-label',
              end > start
                ? 'Reasons ' +
                  start +
                  '–' +
                  end +
                  ' of ' +
                  children.length
                : 'Reason ' +
                  start +
                  ' of ' +
                  children.length
            );

          }
        );


        whySync();

      }


      function whySync() {

        var x =
          why.scrollLeft;

        var active = 0;


        for (
          var i = 1;
          i < stops.length;
          i++
        ) {

          if (
            Math.abs(
              stops[i] - x
            ) <
            Math.abs(
              stops[active] - x
            )
          ) {
            active = i;
          }

        }


        dots.forEach(
          function (dot, index) {

            var isActive =
              index === active;


            dot.classList.toggle(
              'on',
              isActive
            );


            dot.setAttribute(
              'aria-current',
              String(isActive)
            );

          }
        );

      }


      function whyMode() {

        if (
          mediaQuery &&
          mediaQuery.matches
        ) {
          why.setAttribute(
            'tabindex',
            '0'
          );
        } else {
          why.removeAttribute(
            'tabindex'
          );
        }


        whyLayout();

      }


      why.addEventListener(
        'scroll',
        function () {

          window.requestAnimationFrame(
            whySync
          );

        },
        {
          passive: true
        }
      );


      why.addEventListener(
        'focus',
        function () {

          var visible = false;

          try {
            visible =
              why.matches(
                ':focus-visible'
              );
          } catch (error) {
            visible = false;
          }


          if (!visible) {
            return;
          }


          why.scrollIntoView({
            block: 'nearest',
            behavior:
              rm
                ? 'auto'
                : 'smooth'
          });

        }
      );


      dots.forEach(
        function (dot, index) {

          dot.addEventListener(
            'click',
            function () {

              why.scrollTo({
                left:
                  stops[index] || 0,
                behavior:
                  rm
                    ? 'auto'
                    : 'smooth'
              });

            }
          );

        }
      );


      window.addEventListener(
        'resize',
        function () {

          window.requestAnimationFrame(
            whyLayout
          );

        }
      );


      if (mediaQuery) {

        if (
          mediaQuery.addEventListener
        ) {

          mediaQuery.addEventListener(
            'change',
            whyMode
          );

        } else if (
          mediaQuery.addListener
        ) {

          mediaQuery.addListener(
            whyMode
          );

        }

      }


      whyMode();

    }


    /* =========================================================
       PRODUCT TILE ACTIONS
    ========================================================= */

    var toast =
      root.querySelector('.pmToast');

    var toastTimer = null;


    function say(message) {

      if (!toast) {
        return;
      }


      toast.textContent =
        message;


      toast.classList.add(
        'is-on'
      );


      window.clearTimeout(
        toastTimer
      );


      toastTimer =
        window.setTimeout(
          function () {

            toast.classList.remove(
              'is-on'
            );

          },
          2600
        );

    }


    if (grid) {

      grid.addEventListener(
        'click',
        function (event) {

          var button =
            event.target.closest(
              'button[data-act]'
            );


          if (!button) {
            return;
          }


          var name =
            button.getAttribute(
              'data-nm'
            ) || 'Product';


          var action =
            button.getAttribute(
              'data-act'
            );


          if (action === 'wish') {

            var on =
              button.getAttribute(
                'aria-pressed'
              ) !== 'true';


            button.setAttribute(
              'aria-pressed',
              String(on)
            );


            button.classList.toggle(
              'is-on',
              on
            );


            button.setAttribute(
              'aria-label',
              on
                ? 'Remove ' +
                  name +
                  ' from wishlist'
                : 'Add ' +
                  name +
                  ' to wishlist'
            );


            say(
              on
                ? 'Added to wishlist — ' +
                  name +
                  '.'
                : 'Removed from wishlist — ' +
                  name +
                  '.'
            );


            return;
          }


          if (action === 'cart') {

            say(
              'Added to cart — ' +
              name +
              '.'
            );


            return;
          }


          if (action === 'similar') {

            say(
              'Finding pieces similar to ' +
              name +
              '.'
            );

          }

        }
      );

    }


    /* =========================================================
       HERO ANCHOR SCROLL
    ========================================================= */

    $$('.pmHero a[href^="#"]').forEach(
      function (link) {

        link.addEventListener(
          'click',
          function (event) {

            var id =
              link.getAttribute(
                'href'
              ).slice(1);


            var target =
              document.getElementById(
                id
              );


            if (!target) {
              return;
            }


            event.preventDefault();


            var margin =
              parseFloat(
                window.getComputedStyle(
                  target
                ).scrollMarginTop
              ) || 0;


            window.scrollTo({
              top: Math.max(
                0,
                Math.round(
                  target.getBoundingClientRect()
                    .top +
                  window.scrollY -
                  margin
                )
              ),
              behavior:
                rm
                  ? 'auto'
                  : 'smooth'
            });


            try {

              window.history.replaceState(
                null,
                '',
                '#' + id
              );

            } catch (error) {}


            if (
              !target.hasAttribute(
                'tabindex'
              )
            ) {

              target.setAttribute(
                'tabindex',
                '-1'
              );

            }


            try {

              target.focus({
                preventScroll: true
              });

            } catch (error) {}

          }
        );

      }
    );


    /* =========================================================
       SHOPIFY THEME EDITOR SUPPORT
    ========================================================= */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        if (
          event.target &&
          event.target.contains(root)
        ) {
          initPowermark(root);
        }

      }
    );

  }


  /* ===========================================================
     INITIALIZE ALL POWERMARK SECTIONS
  =========================================================== */

  function initAll() {

    document
      .querySelectorAll('.pm[data-section-id]')
      .forEach(function (root) {

        initPowermark(root);

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

})();